import { getTimestampUTC } from '@omni/kit/utilities/utilities';
import moment from 'moment-timezone';

// Function to calculate event duration in minutes needed for repeating events
export const getEventDuration = (
  startDate: Date,
  startTime: string,
  endDate: Date,
  endTime: string,
  timezone: string
): number | undefined => {
  // Use the existing getTimestampUTC function to convert start and end date/time to UTC
  const startTimestamp = getTimestampUTC(startDate, startTime, timezone);
  const endTimestamp = getTimestampUTC(endDate, endTime, timezone);

  // Calculate the duration in milliseconds
  const durationMilliseconds =
    new Date(endTimestamp).getTime() - new Date(startTimestamp).getTime();

  if (durationMilliseconds < 0) {
    return undefined;
  }

  // Convert milliseconds to minutes (or hours)
  const durationInMinutes = durationMilliseconds / (1000 * 60); // Duration in minutes

  return Math.round(durationInMinutes); // Return the rounded duration in minutes
};

export const calculateEndDateTime = (
  startDate: Date,
  startTime: string,
  timezone: string,
  durationMinutes: number
): { endAt: string; endTime: string } => {
  const startTimestamp = getTimestampUTC(startDate, startTime, timezone);
  const startMoment = moment(startTimestamp).tz(timezone);
  const endMoment = startMoment.add(durationMinutes, 'minutes');
  const endAt = startMoment.format();
  const endTime = endMoment.format('HHmm');

  return { endAt, endTime };
};
